import { Store } from '@ngrx/store';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs/Observable';

// Reducers & Actions
import * as Account from '../../../my-account/actions/account.actions';
import * as fromAuth from '../../../auth/reducers';
import * as fromCore from '../../../core/reducers';

@Component({
  selector: 'phone-verification-modal',
  templateUrl: './phone-verification-modal.component.html',
  styleUrls: ['./phone-verification-modal.component.scss']
})
export class PhoneVerificationModalComponent implements OnInit {

  // Output Method
  @Output() onFormSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onModalClose: EventEmitter<any> = new EventEmitter<any>();

  // Form Group
  public tfaForm: FormGroup;
  private pattern = /[0-9]/;

  // Observable Variables
  public tfaModalOpened$: Observable<boolean> = this.coreStore.select(state => state.core.account.tfaModalOpened);

  // Constructor
  constructor(
    private authStore: Store<fromAuth.State>,
    private coreStore: Store<fromCore.State>,
    private formBuilder: FormBuilder
  ) { }

  // On component init
  ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/phone-verification-modal/phone-verification-modal.component.ts